"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var START_FRAGMENT = '<!--StartFragment-->';
var END_FRAGMENT = '<!--EndFragment-->';
/**
 * Build DOM tree from the given HTML string
 * @param html Source HTML string
 * @param preserveFragmentOnly If there is fragment markup (&lt;!--StartFragment--&gt; and &lt;!--EndFragment--&gt;),
 * only preserve content between these markups
 * @param fragmentHandler An optional callback to do customized fragment handling
 */
function htmlToDom(html, preserveFragmentOnly, fragmentHandler) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html || '', 'text/html');
    if (doc && doc.body && doc.body.firstChild) {
        // 1. Filter out html code outside of Fragment tags if need
        if (preserveFragmentOnly) {
            (fragmentHandler || defaultFragmentTrimmer)(doc, html);
        }
        return doc;
    }
    else {
        return null;
    }
}
exports.default = htmlToDom;
function defaultFragmentTrimmer(doc, sourceHtml) {
    var html = splitWithFragment(sourceHtml)[0];
    doc.body.innerHTML = html;
}
/**
 * Split the HTML string using its fragment info
 * @param html Source html string
 * @returns [String within fragment, String before fragment, String after fragment]
 */
function splitWithFragment(html) {
    var startIndex = html.indexOf(START_FRAGMENT);
    var endIndex = html.lastIndexOf(END_FRAGMENT);
    if (startIndex >= 0 && endIndex >= 0 && endIndex >= startIndex + START_FRAGMENT.length) {
        var before = html.substr(0, startIndex);
        var after = html.substr(endIndex + END_FRAGMENT.length);
        html = html.substring(startIndex + START_FRAGMENT.length, endIndex);
        return [html, before, after];
    }
    else {
        return [html, null, null];
    }
}
exports.splitWithFragment = splitWithFragment;
//# sourceMappingURL=htmlToDom.js.map